import axios from "@/axios";

const getDefaultState = () => ({
    unidade: {},
});

const state = getDefaultState();

const mutations = {
    SET_UNIDADE(state, unidade) {
        state.unidade = unidade;
    },
    reset(state) {
        Object.assign(state, getDefaultState());
    }
};

const actions = {
    async fetchUnidade({ commit, rootState }, unidadeId) {
        try {
            const unidades = rootState.unidades.unidades;
            const unidadeEncontrada = unidades.find(u => parseInt(u.id) === parseInt(unidadeId));

            if (unidadeEncontrada) {
                commit('SET_UNIDADE', unidadeEncontrada);
            } else {
                const response = await axios.get(`/unidades/${unidadeId}`);
                const data = response.data;
                commit('SET_UNIDADE', data.unidade);
            }
			
        } catch (error) {
            console.error('Erro ao buscar unidade:', error);
            commit('SET_UNIDADE', {});
            throw error;
        }
    },

    async storeParametrosConfiguracoes(_, {unidadeId, data}) {
        try {
            return await axios.post(`/unidades/${unidadeId}/parametros-configuracoes`, data)
        } catch (error) {
            console.error('Erro ao salvar parametros configuracoes da unidade:', error);
            throw error;
        }
    },

    async getParametrosConfiguracoes(_, unidadeId) {
        try {
            const response = await axios.get(`/unidades/${unidadeId}/parametros-configuracoes`)
            return response.data.parametrosConfiguracoes;
        } catch (error) {
            console.error('Erro ao buscar parametros configuracoes da unidade:', error);
            throw error;
        }
    },

    async getServicoStatus(_, unidadeId) {
        try {
            const response = await axios.get(`/unidades/${unidadeId}/servico/status`)
            return response;
        } catch (error) {
            console.error('Erro ao buscar parametros configuracoes da unidade:', error);
            throw error;
        }
    },

    async getEstacaoByUnidade(_, unidadeId) {
        try {
            const response = await axios.get(`/unidades/${unidadeId}/estacao`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar estacao da unidade:', error);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
